import React from 'react';
import { Table } from 'reactstrap';
import NumberCommas from '../../../Components/NumberCommas/NumberCommas';

const PrintableTable = ({ filteredData }) => {
  return (
    <Table hover bordered className="print-table">
      <thead className="table-light">
        <tr>
          <th style={{ width: "75px" }}>S.N</th>
          <th>Title</th>
          <th style={{ width: "120px" }}>Unit</th>
          <th>Menu Category</th>
          <th style={{ width: "100px" }}>Price</th>
          {/* <th style={{ width: "140px" }}>Recipe Price</th>
          <th style={{ width: "150px" }}>Actual FC(%)</th> */}
        </tr>
      </thead>
      <tbody>
        {filteredData.map((row, index) => (
          <tr key={row.id}>
            <td>{index + 1}</td> {/* Simple sequential numbering */}
            <td>{row.title}</td>
            <td>{row.unit || "N/A"}</td>
            <td>{row.menuCategory}</td>
            <td className="text-end"><NumberCommas number={row.price || "N/A"} /></td>
            {/* <td className="text-end"><NumberCommas number={row.recipePrice} /></td>
            <td className="text-end"><NumberCommas number={row.profitMargin} /></td> */}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default PrintableTable;